module.exports = __webpack_public_path__ + "static/img/Darcy.b9a5782.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Darcy.jpg
// module id = 4QoO
// module chunks = 0